import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"
import { CssHelper } from "~/helpers/css_helper"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)
export default class extends Controller {
  static targets = ["chart"]

  connect() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch the preview
    if (NavigationHelper.pageIsPreview()) { return }

    this.load()
  }

  load() {
    var datasets, labels

    var el = this.chartTarget

    if (el.dataset.statuses === "true") {
      if (el.dataset.bulkType === "verification") {
        datasets = [
          {
            data: [el.dataset.valid, el.dataset.accept_all, el.dataset.invalid, el.dataset.webmail, el.dataset.disposable, el.dataset.unknown],
            backgroundColor: [
              CssHelper.getVar("--colors-success-600"),
              CssHelper.getVar("--colors-warning-600"),
              CssHelper.getVar("--colors-danger-600"),
              CssHelper.getVar("--colors-magenta-500"),
              CssHelper.getVar("--colors-secondary-600"),
              CssHelper.getVar("--colors-grey-300")
            ],
            borderWidth: [3, 3, 3, 3, 3, 3]
          }
        ]

        labels = [i18n.t("js.verification_status.valid"), i18n.t("js.verification_status.accept_all"), i18n.t("js.verification_status.invalid"), i18n.t("js.verification_status.webmail"), i18n.t("js.verification_status.disposable"), i18n.t("js.verification_status.unknown")]
      } else if (el.dataset.bulkType === "finder") {
        datasets = [
          {
            data: [el.dataset.valid, el.dataset.accept_all, el.dataset.invalid, el.dataset.unknown, el.dataset.not_found],
            backgroundColor: [
              CssHelper.getVar("--colors-success-600"),
              CssHelper.getVar("--colors-warning-500"),
              CssHelper.getVar("--colors-danger-600"),
              CssHelper.getVar("--colors-grey-300"),
              CssHelper.getVar("--colors-grey-500")
            ],
            borderWidth: [3, 3, 3, 3, 3]
          }
        ]

        labels = [i18n.t("js.verification_status.valid"), i18n.t("js.verification_status.accept_all"), i18n.t("js.verification_status.unknown"), i18n.t("js.verification_status.invalid"), i18n.t("js.back.bulks.bulk_email_finders.not_found")]
      }
    } else {
      datasets = [
        {
          data: [el.dataset.deliverable, el.dataset.risky, el.dataset.undeliverable],
          backgroundColor: [
            CssHelper.getVar("--colors-success-600"),
            CssHelper.getVar("--colors-warning-500"),
            CssHelper.getVar("--colors-danger-600")
          ],
          borderWidth: [2, 2, 2]
        }
      ]

      labels = [i18n.t("js.verification_status.valid"), i18n.t("js.verification_status.risky"), i18n.t("js.verification_status.invalid")]
    }

    var config = {
      type: "doughnut",
      data: {
        datasets: datasets,
        labels: labels
      },
      options: {
        events: null,
        responsive: true,
        cutout: "60%",
        animation: {
          animateRotate: false,
          duration: 0
        },
        layout: {
          padding: {
            left: 0
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            displayColors: false,
            yAlign: "bottom",
            padding: 8,
            titleFont: {
              family: CssHelper.getVar("--fonts-family-body")
            },
            cornerRadius: 4
          }
        }
      }
    }

    new Chart(el.getContext("2d"), config)
  }
}
